// Reusable avatar with tier border.
// Tier keys: sprout / grove / canopy / forest / ecosystem (or null = no border)
// Uses CSS ring classes to give each tier a distinct glow.

import { BACKEND_URL } from "@/lib/api";

const TIER_RING = {
  sprout:    "ring-2 ring-emerald-400/70",
  grove:     "ring-2 ring-lime-400/80",
  canopy:    "ring-2 ring-primary shadow-[0_0_12px_hsl(var(--primary)/0.5)]",
  forest:    "ring-[3px] ring-primary shadow-[0_0_16px_hsl(var(--primary)/0.7)]",
  ecosystem: "ring-[3px] ring-primary shadow-[0_0_24px_hsl(var(--primary))] animate-pulse",
};

const resolve = (u) => (u?.startsWith("http") ? u : `${BACKEND_URL}${u}`);

const SIZES = {
  xs: "h-6 w-6 text-[10px]",
  sm: "h-8 w-8 text-xs",
  md: "h-12 w-12 text-sm",
  lg: "h-20 w-20 text-2xl",
  xl: "h-28 w-28 text-3xl",
};

export default function AvatarTiered({ user, size = "sm", tier: tierOverride, className = "", testId }) {
  if (!user) return null;
  const tier = tierOverride ?? user.avatar_tier ?? null;
  const ring = TIER_RING[tier] || "";
  const sizeCls = SIZES[size] || SIZES.sm;
  const initial = (user.display_name || user.name || "?")[0]?.toUpperCase();
  return (
    <div
      data-testid={testId}
      className={`relative inline-flex items-center justify-center overflow-hidden bg-primary/20 font-bold text-primary ${sizeCls} ${ring} ${className}`}
      title={tier ? `Tier: ${tier}` : undefined}
    >
      {user.avatar_url ? (
        <img src={resolve(user.avatar_url)} alt={user.display_name} className="h-full w-full object-cover" />
      ) : (
        <span>{initial}</span>
      )}
    </div>
  );
}
